import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import SentryRRWeb from '@sentry/rrweb';
import { Integrations } from '@sentry/tracing';
// eslint-disable-next-line no-unused-vars
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import { Provider } from 'react-redux';

import App from 'src/App';
import { sanitizeSentryEvent } from 'src/functions/sentry';
import Store from 'src/store';
import * as serviceWorker from './serviceWorker';

const history = createBrowserHistory();

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV || 'local',
    release: process.env.REACT_APP_SENTRY_RELEASE || 'local',
    tracePropagationTargets:
      process.env.REACT_APP_ENV === 'prod'
        ? [
            'https://auth.selfgrowth.guide',
            'https://api.selfgrowth.guide',
            'https://auth.pinpoint.ai',
            'https://api.pinpoint.ai',
            'https://api.pinpointpredictive.io',
          ]
        : [
            'https://stage-auth.selfgrowth.guide',
            'https://stage-api.selfgrowth.guide',
            'https://stage-auth.pinpoint.ai',
            'https://stage-api.pinpoint.ai',
            'https://stage-api.pinpointpredictive.io',
          ],
    integrations: [
      /* NOTE: Leave this here for now, might revisit later
       * new Sentry.Replay({
       *   // Additional SDK configuration goes in here, for example:
       *   maskAllText: true,
       *   blockAllMedia: true,
       * }),
       */
      new Integrations.BrowserTracing({
        heartbeatInterval: 20000,
        idleTimeout: 60000,
        finalTimeout: 60000,
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
      }),
      new SentryRRWeb({}),
    ],
    tracesSampleRate: 1.0,
    normalizeDepth: 3,
    maxBreadcrumbs: 50,
    beforeSend: sanitizeSentryEvent,
  });
}

// GoldenLayout context variables
window.React = React;
window.ReactDOM = ReactDOM;
window.Store = Store;

ReactDOM.render(
  <Provider store={Store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
